module.exports = __webpack_public_path__ + "img/m_role_4_name.7f972287.png";